import { Card } from "react-bootstrap";
import { Link } from "react-router-dom";

function ArticleCard({ article }) {
  return (
    <Card className="fi-card">
      <Card.Body className="d-flex flex-column">
        <div className="fi-card-icon">{article.emoji}</div>
        <Card.Title as="h5" className="fw-bold">
          {article.title}
        </Card.Title>
        <Card.Text className="text-muted flex-grow-1">{article.excerpt}</Card.Text>
        <div className="d-flex justify-content-between align-items-center mt-2">
          <Link
            to={`/article/${article.slug}`}
            className="fw-semibold"
            style={{ color: "var(--fi-primary)" }}
          >
            Read more →
          </Link>
          {/* <small className="text-muted">⏱ {article.readTime} min</small> */}
        </div>
      </Card.Body>
    </Card>
  );
}

export default ArticleCard;
